import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from '../utils/axios';
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetAllVendorTagsQuery = () => {
    const { data, isPending, isError, error } = useQuery({
        queryKey: [API_ROUTES.GET_ALL_VENDOR_TAGS],
        queryFn: () => api.get(API_ROUTES.GET_ALL_VENDOR_TAGS),
    });
    return { data: data?.data?.data ?? [], isPending, isError, error };
};


export const useGetVendorTagByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_VENDOR_TAG_BY_ID, id],
    queryFn: () => api.get(API_ROUTES.GET_VENDOR_TAG_BY_ID.replace(":id", id)),
    enabled: !!id, // Only run query if ID is provided
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useAddVendorTagMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.post(API_ROUTES.CREATE_VENDOR_TAG, data),
      onSuccess: () => {
        showToast("success", "Vendor tag created successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_ALL_VENDOR_TAGS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useUpdateVendorTagMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.put(`${API_ROUTES.UPDATE_VENDOR_TAG.replace(":id", data?.id)}`, data),
      onSuccess: () => {
        showToast("success", "Vendor tag updated successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_ALL_VENDOR_TAGS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeleteVendorTagMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) =>
        api.delete(`${API_ROUTES.DELETE_VENDOR_TAG.replace(":id", id)}`),
      onSuccess: () => {
        showToast("success", "Vendor tag deleted successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_ALL_VENDOR_TAGS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
